import React from 'react'
import './PortfolioPageComponent.css';

export const PortfolioPageComponent = () => {
  return (
    <div>PortfolioPageComponent</div>
  )
}
